function TrianualActionButton({ children, tone = 'primary', onClick }) {
  const toneClass =
    tone === 'secondary'
      ? 'from-[#245b79] to-[#184865]'
      : 'from-[#1d9657] to-[#177d4a]';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full rounded-[12px] bg-gradient-to-b px-4 py-4 font-login text-[14px] font-bold text-white shadow-[0_5px_10px_rgba(15,23,42,0.24)] transition hover:-translate-y-0.5 hover:brightness-105 ${toneClass} sm:py-4 sm:text-[15px]`}
    >
      {children}
    </button>
  );
}

export default TrianualActionButton;
